<app-header
  *ngIf="(model$ | async)?.isAuthenticated"
  [model]="(model$ | async)?.header"
></app-header>
<div *ngIf="!(model$ | async)?.isAuthenticated">
  <app-splash-screen></app-splash-screen>
</div>
<div class="container-fluid body-content">
  <router-outlet></router-outlet>
</div>
